import React, { useMemo } from "react";
import { DSProvider } from "@toddle-edu/ds-web";
import classes from "./StandardsTable.scss";
import classNames from "classnames";
import { Body, Grid, Header } from "./components";
import { StandardsTableProvider } from "./context/StandardsTableContext";
import DataGridOutline, {
  useDataGridOutline,
} from "AppComponents/DataGridOutline";

const StandardsTable = props => {
  const {
    children,
    tableClass,
    nodeMap,
    columns,
    properties,
    actionHandlerFn,
    sideNavData = [],
    showOutline = false,
    showLoader = false,
  } = props;

  // Use the DataGridOutline hook for outline functionality
  const { gridProps, outlineProps } = useDataGridOutline({ sideNavData });

  // Enhance outline props with additional configuration
  const enhancedOutlineProps = useMemo(
    () => ({
      ...outlineProps,
      showLoader,
    }),
    [outlineProps, showLoader]
  );

  const containerClass = classNames(classes.container, tableClass);

  const contextValue = useMemo(
    () => ({
      nodeMap,
      columns,
      properties,
      actionHandlerFn,
      // Outline-related context
      gridProps,
    }),
    [nodeMap, columns, properties, actionHandlerFn, gridProps]
  );

  return (
    <DSProvider dsVersion="2.0">
      <StandardsTableProvider value={contextValue}>
        <div className={containerClass}>
          {showOutline && <DataGridOutline {...enhancedOutlineProps} />}
          {children}
        </div>
      </StandardsTableProvider>
    </DSProvider>
  );
};

const MemoizedStandardsTable = React.memo(StandardsTable);

MemoizedStandardsTable.Body = Body;
MemoizedStandardsTable.Grid = Grid;
MemoizedStandardsTable.Header = Header;

export default MemoizedStandardsTable;
